import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "pane"]
  static values = { defaultTab: String }

  connect() {
    const hash = window.location.hash.replace("#", "")
    const tab = hash || this.defaultTabValue
    if (tab) {
      this.activate(tab)
    }
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.urlTabsTab
    this.activate(tab)
    history.replaceState(null, "", `#${tab}`)
  }

  activate(tab) {
    this.tabTargets.forEach(el => {
      el.classList.toggle("active", el.dataset.urlTabsTab === tab)
    })
    this.paneTargets.forEach(el => {
      el.classList.toggle("active", el.id === tab)
      el.classList.toggle("show", el.id === tab)
    })
  }
}
